import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.carto2;

export const cartoSelectors = {
  carto: createSelector(selector, (state) => state.carto),
};
